import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Hero from './sections/Hero';
import { Chat } from './components/Chat';
import AINewsAggregator from './sections/AINewsAggregator';
import AIEggIndex from './sections/AIEggIndex';
import Footer from './components/Footer';
import DemoPage from './pages/DemoPage';
import DemosPage from './pages/DemosPage';
import AINewsAggregatorPage from './pages/AINewsAggregatorPage';
import BenchmarkPage from './pages/BenchmarkPage';
import WikiPage from './pages/WikiPage';
import EvalMethodsArticle from './pages/wiki/EvalMethodsArticle';
import RagEvalArticle from './pages/wiki/RagEvalArticle';
import ErrorMarginArticle from './pages/wiki/ErrorMarginArticle';
import AIEggIndexArticle from './pages/blog/AIEggIndexArticle';

function HomePage() {
  return (
    <>
      <main>
        <Hero />
        <section className="chat-section-wrapper">
          <Chat />
        </section>
        <AINewsAggregator />
        <AIEggIndex />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <HashRouter>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/demos" element={<DemosPage />} />
          <Route path="/demo/:demoId" element={<DemoPage />} />
          <Route path="/ai-news-aggregator" element={<AINewsAggregatorPage />} />
          <Route path="/benchmarks" element={<BenchmarkPage />} />
          <Route path="/blog/ai-egg-index" element={<AIEggIndexArticle />} />
          <Route path="/wiki" element={<WikiPage />} />
          <Route path="/wiki/eval-methods" element={<EvalMethodsArticle />} />
          <Route path="/wiki/rag-eval" element={<RagEvalArticle />} />
          <Route path="/wiki/error-margins" element={<ErrorMarginArticle />} />
        </Routes>
      </div>
    </HashRouter>
  );
}

export default App;
